__turbopack_context__.v({
  "horizontal": "tabs-module-scss-module__lejYDG__horizontal",
  "panels-container": "tabs-module-scss-module__lejYDG__panels-container",
  "tabs": "tabs-module-scss-module__lejYDG__tabs",
  "vertical": "tabs-module-scss-module__lejYDG__vertical",
});
